import { useCallback, useState } from 'react';

import { useDrag } from '~/hooks/smart-search';

import SmartSearchHeader from './SmartSearchHeader';

import styles from './MiniBar.module.scss';

const MINIBAR_SIZE = { width: 400, height: 49 };
const VIEWPORT_MARGIN = 16;

const getInitialPosition = () => ({
  x: window.innerWidth - MINIBAR_SIZE.width - VIEWPORT_MARGIN,
  y: window.innerHeight - MINIBAR_SIZE.height - VIEWPORT_MARGIN,
});

const MiniBar = () => {
  const [position, setPosition] = useState(getInitialPosition);
  const getSize = useCallback(() => MINIBAR_SIZE, []);
  const { dragProps } = useDrag(position, setPosition, getSize);

  return (
    <div className={styles['minibar']} style={{ left: position.x, top: position.y }} {...dragProps}>
      <SmartSearchHeader />
    </div>
  );
};

export default MiniBar;
